<template>
  <div>
    <b-modal
      id="modal-advanced-container-search"
      title="Advanced Search"
      modal-ok="SEARCH"
      @ok="searchUnits"
    >
      <div class="row" v-show="current_profile.type!=6">
        <div class="col pt-3">
          <b-input-group prepend="Customer">
            <b-form-input placeholder="Customer name" v-model="selected_customer" />
            <b-input-group-append>
              <b-button @click="$bvModal.show('modal-consignee-list');">
                <b-icon icon="search" variant="success" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
      <div class="row" v-show="current_profile.type!=4">
        <div class="col pt-3">
          <b-input-group prepend="Carrier">
            <b-form-select :options="carrier_options" v-model="selected_carrier"></b-form-select>
          </b-input-group>
        </div>
      </div>
      <div class="row">
        <div class="col pt-3">
          <b-input-group prepend="Location">
            <b-form-select :options="location_options" v-model="selected_location"></b-form-select>
          </b-input-group>
        </div>
      </div>
      <div class="row">
        <div class="col pt-3">
          <b-input-group prepend="Status">
            <b-form-select :options="status_options" v-model="selected_status"></b-form-select>
          </b-input-group>
        </div>
      </div>
      <div class="d-flex flex-row pt-3">
        <b-dropdown id="ref-type" :text="date_type_text" variant="warning">
          <b-dropdown-item-button @click="toggleDateType(1)">Discharge</b-dropdown-item-button>
          <b-dropdown-item-button @click="toggleDateType(2)">Gate OUT</b-dropdown-item-button>
          <b-dropdown-item-button @click="toggleDateType(3)">Gate IN</b-dropdown-item-button>
        </b-dropdown>

        <b-form-datepicker
          id="start-date"
          today-button
          reset-button
          close-button
          locale="en"
          placeholder="Start date"
          v-model="date_start"
        />

        <b-form-datepicker
          id="end-date"
          today-button
          reset-button
          close-button
          locale="en"
          placeholder="End date"
          v-model="date_end"
        />
      </div>

      <div class="d-flex justify-content-center pt-3">
        <b-form-checkbox
          id="checkbox-only-units-with-AR"
          v-model="only_units_with_AR"
          name="checkbox-only-units-with-AR"
          switch
          style="width=100px"
        >show only units with an outstanding</b-form-checkbox>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="success" @click="ok()">SEARCH</b-button>
        <b-button variant="danger" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: function () {
    return {
      date_type: 1,
      date_type_text: "Discharge",
      date_start: null,
      date_end: null,

      only_units_with_AR: false,

      selected_customer: null,
      selected_carrier: null,
      selected_location: null,
      selected_status: null,

      status_options: [
        { value: null, text: "ALL" },
        { value: null, text: "------", disabled: true },
        { value: "FULL", text: "FULL" },
        { value: "EMPTY", text: "EMPTY" },
      ],
      location_options: [
        { value: null, text: "ALL" },
        { value: null, text: "-------------", disabled: true },
        { value: "CONSIGNEE", text: "AT CONSIGNEE" },
        { value: "TERMINAL", text: "AT TERMINAL" },
        /*
        { value: null, text: "-------------", disabled: true },
        { value: "CPS", text: "CPS" },
        { value: "LAFITO", text: "LAFITO" },
        */
      ],
      carrier_options: [
        { value: null, text: "ALL" },
        { value: null, text: "-------------", disabled: true },
        { value: "ANTILEAN", text: "ANTILEAN" },
        { value: "COSCO", text: "COSCO" },
        //{ value: "CMACGM", text: "CMA-CGM" },
        { value: "CROWLEY", text: "CROWLEY" },
        { value: "EVGR", text: "EVERGREEN" },
        { value: "HAMSUD", text: "HAMSUD" },
        { value: "HAPAG-CSAV", text: "HAPAG-CSAV" },
        { value: "MAERSK", text: "MAERSK" },
        { value: "MSC", text: "MSC" },
        { value: "SEALAND", text: "SEALAND" },
      ],
    };
  },
  computed: {
    ...mapState(["current_profile","carrier_list"]),
  },
  methods: {
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      //if (!this.checkFormValidity()) {
      //  return;
      //}
      // Push the name to submitted names
      // this.submittedNames.push(this.name);
      // Hide the modal manually

      this.$nextTick(() => {
        this.$bvModal.hide("modal-advanced-container-search");
      });
    },
    toggleDateType(date_type) {
      this.date_type = date_type;
      switch (this.date_type) {
        case 1:
          this.date_type_text = "Discharge";
          break;
        case 2:
          this.date_type_text = "Gate OUT";
          break;
        case 3:
          this.date_type_text = "Gate IN";
          break;
      }
    },
    searchUnits(bvModalEvt) {
      bvModalEvt.preventDefault();

      let Type = 3;
      let client_id = this.selected_customer;
      let date_type = this.date_type;
      let date_start = this.date_start;
      let date_end = this.date_end;
      let carrier = this.selected_carrier;
      let location = this.selected_location;
      let status = this.selected_status;
      let only_units_with_AR = this.only_units_with_AR;

      let payload = {
        Type,
        client_id,
        date_type,
        date_start,
        date_end,
        carrier,
        location,
        status,
        only_units_with_AR,
      };
      let action = "get_units";

      this.$store
        .dispatch(action, payload)
        .then(() => {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-advanced-container-search");
          });
        })
        .catch((err) => {
          alert(err.message);
        });
    },
  },
};
</script>
